/** Letters NFD leaves whole, folded the way the backend's `unaccent` does. */
const UNDECOMPOSED: Record<string, string> = { ł: 'l', ø: 'o', đ: 'd', ß: 'ss', æ: 'ae', œ: 'oe' };

/**
 * Folds case and diacritics so a plain `includes` match treats "martins" and "Mārtiņš" as equal.
 * Decomposes to NFD then drops the combining marks, leaving the base Latin letters; the few letters
 * NFD does not decompose are mapped by hand, so the result can be longer than the input (ß → ss).
 * Apply to both the query and each searched field.
 */
export const foldForSearch = (value: string): string =>
    value
        .toLowerCase()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .replace(/[łøđßæœ]/g, (letter) => UNDECOMPOSED[letter]);
